<template>
  <workbenchDetail
    @cancelCallBack="cancel"
    @approvalConfirm="approvalConfirm"
    :backlogModel="backlogModel"
    :width="width"
    :isHide="isHide"
  >
    <div slot="content">
      <el-form label-width="130px" :model="dataForm">
        <el-form-item label="机构名称：">
          {{ dataForm.Name }}
        </el-form-item>
        <el-form-item label="联系人：">
          {{ dataForm.ContactUser }}
        </el-form-item>
        <el-form-item label="联系电话：">
          {{ dataForm.Phone }}
        </el-form-item>
         <el-form-item label="电子邮箱：">
          {{ dataForm.Email }}
        </el-form-item>
         <el-form-item label="报名人数：">
          {{ dataForm.SignUpNum }}（人）
        </el-form-item>
        <el-form-item label="讲座类型：">
          {{ dataForm.LectureType === 0?'公益':'收费' }}
        </el-form-item>
         <el-form-item label="审核状态：">
          {{ showApplyStatus(dataForm.ApplyStatus) }}
        </el-form-item>
         <el-form-item label="培训金额：">
          {{ dataForm.Amount }}元
        </el-form-item>
        <el-form-item label="是否提供场地：">
          {{ dataForm.IsVenue?'是':'否' }}
        </el-form-item>
         <el-form-item label="支付状态：">
          {{ dataForm.IsPay === 0?'未支付':'已支付' }}
        </el-form-item>
         <el-form-item label="培训时间：">
          {{ dataForm.TrainTime * 1000 | formatDate }}
        </el-form-item>
         <el-form-item label="培训地点：">
          {{ dataForm.TrainAddress || '-' }}
        </el-form-item>
         <el-form-item label="合作协议：">
          <el-row>
            <el-col :span="20">{{file.FileName}}</el-col>
            <el-col :span="4">
                <el-button type="text" @click="download">下载</el-button>
            </el-col>
        </el-row>
        </el-form-item>
      </el-form>
    </div>
  </workbenchDetail>
</template>
<script>
import workbenchDetail from "@/modules/zjrc/pages/workbench/common/workbenchDetail";
import api from "@/modules/zjrc/api";
import { saveAs } from "file-saver";
import { formatData } from "@/utils/index";

export default {
  name: "audit",
  props: {
    backlogModel: {
      type: Object,
      default: null,
    },
    isHide: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataForm: {}, //表单对象
      file: {}, //附件
      width: "55%",
    };
  },
  components: {
    workbenchDetail
  },
  mounted() {
    let that = this;
    that.loadData();
  },
  methods: {
    download(){
      const vm = this
      saveAs('/file' + vm.file.StorePath)
    },
    showApplyStatus(value){
      return formatData(value,this.lectureApplyStatus)
    },
    //初始化数据
    loadData() {
      let that = this;
      let params = { Id: that.backlogModel.BusinessId };
      api.QueryLectureApplyById(params).then((res) => {
        if (res.data.Code == 0) {
          that.dataForm = res.data.Data;
          that.getFile();
        }
      });
    },
    //取消
    cancel() {
      this.$emit("auditCallBack", null);
    },
    //提交数据
    approvalConfirm(data) {
      let params = Object.assign({}, data);
      api
        .AuditLectureApply(params)
        .then((res) => {
          if (res.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            this.$emit("auditCallBack", params);
          } else {
            this.$message({
              message: res.data.Message,
              type: "error",
            });
          }
        })
        .catch((e) => {
          this.$message({
            message: e.toString(),
            type: "error",
          });
        });
    },
    //初始化附件
    getFile() {
      const vm = this
      if (
        vm.dataForm.File === undefined ||
        vm.dataForm.File === null ||
        vm.dataForm.File == ""
      ) {
        return;
      }
      const request = {id: vm.dataForm.File}
      api.QueryBigSickApplyFileByIds(request).then(res=>{
        if(res.data.Code === 0 && res.data.Data !== null && res.data.Data.length > 0){
          vm.file = res.data.Data[0]
        }
      })
    }
  },
};
</script>

<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.hideFile >>> .el-upload-list__item-delete {
  display: none !important;
}
.hideFile >>> .el-icon-close {
  display: none !important;
}
.hideFile >>> .el-icon-close-tip {
  display: none !important;
}
</style>

<style>
.hidePic .el-upload--picture-card {
  display: none !important;
}

.hideFile .el-upload--fileList {
  display: none !important;
}
</style>